import { DEPARTMENTS } from "helpers/url_helper";

export const ENCRYPTION_CONSTANTS = {
    KEYSIZE: 128,
    ITERATION_COUNT: 1000,
    PASSPHRASE: 'iZVhQrsuAwzU7j2pOkywChQ1wawN996fDU8NbIRLGS3G7fLm7y'
};

export const CONSTANTS = {
    ROLES: {
        ADMIN: 'ADMIN',
        CORPORATE_NODAL_OFFICER: 'CORPORATE_NODAL_OFFICER',
        NODAL_OFFICER: 'NODAL_OFFICER',
        USER: 'USER'
    },
    ROLE_IDS: {
        ADMIN: 'R1023',
        CORPORATE_NODAL_OFFICER: 'R2048',
        NODAL_OFFICER: 'R3071',
        USER: 'R4096'
    }
};

export const rolePrivilegesMap: any = {
    admin: [
        { value: 'ADD_AREAS', label1: 'Add Areas' },
        { value: 'VIEW_AREAS', label1: 'View Areas' },
        { value: 'ACTIVE/INACTIVE_AREAS', label1: 'Active/Inactive Areas' },
        { value: 'EDIT_AREAS', label1: 'Edit Areas' },
        { value: 'DELETE_AREAS', label1: 'Delete Areas' },
        { value: 'ADD_MINES', label1: 'Add Mines' },
        { value: 'VIEW_MINES', label1: 'View Mines' },
        { value: 'EDIT_MINES', label1: 'Edit Mines' },
        { value: 'DELETE_MINES', label1: 'Delete Mines' },
        { value: 'ADD_SOURCES', label1: 'Add Sources' },
        { value: 'VIEW_SOURCES', label1: 'View Sources' },
        { value: 'EDIT_SOURCES', label1: 'Edit Sources' },
        { value: 'DELETE_SOURCES', label1: 'Delete Sources' },
        { value: 'ADD_3D_LAYER', label1: 'Add 3D Layer' },
        { value: 'VIEW_3D_LAYER', label1: 'View 3D Layer' },
        { value: 'EDIT_3D_LAYER', label1: 'Edit 3D Layer' },
        { value: 'DELETE_3D_LAYER', label1: 'Delete 3D Layer' },
        { value: 'ADD_REPORTS', label1: 'Add Reports' },
        { value: 'VIEW_REPORTS', label1: 'View Reports' },
        { value: 'EDIT_REPORTS', label1: 'Edit Reports' },
        { value: 'DELETE_REPORTS', label1: 'Delete Reports' },
        { value: 'ADD_RECORDS', label1: 'Add Records' },
        { value: 'VIEW_RECORDS', label1: 'View Records' },
        { value: 'EDIT_RECORDS', label1: 'Edit Records' },
        { value: 'DELETE_RECORDS', label1: 'Delete Records' },
        { value: 'ADD_USERS', label1: 'Add Users' },
        { value: 'VIEW_USERS', label1: 'View Users' },
        { value: 'EDIT_USERS', label1: 'Edit Users' },
        { value: 'DELETE_USERS', label1: 'Delete Users' },
        { value: 'VIEW_REQUESTS', label1: 'View Requests' },
        { value: 'TAKE_ACTION_ON_REQUESTS', label1: 'Take Action on Requests' },
        { value: 'DELETE_REQUESTS', label1: 'Delete Requests' },
        { value: 'VIEW_MODIFIED_ENTRIES', label1: 'View Modified Entries' },
        { value: 'TAKE_ACTION_ON_MODIFIED_ENTRIES', label1: 'Take Action on Modified Entries' },
        { value: 'VIEW_NEWLY_ADDED_ENTRIES', label1: 'View Newly Added Entries' },
        { value: 'TAKE_ACTION_ON_NEWLY_ADDED_ENTRIES', label1: 'Take Action on Newly Added Entries' },
        { value: 'ADD_EMPLOYEE_IDS', label1: 'Add Employee IDs' },
        { value: 'UPLOAD_EMPLOYEE_IDS', label1: 'Upload Employee IDs' },
        { value: 'VIEW_EMPLOYEE_IDS', label1: 'View Employee IDs' },
        { value: 'EDIT_EMPLOYEE_IDS', label1: 'Edit Employee IDs' },
        { value: 'DELETE_EMPLOYEE_IDS', label1: 'Delete Employee IDs' },
        { value: 'VIEW_INFORMATION_MANAGEMENT', label1: 'View Information Management' },
        { value: 'ADMIN_MAP_VIEW', label1: 'Admin Map View' },
        { value: 'DASHBOARD', label1: 'Dashboard' },
        { value: 'DEPARTMENTS', label1: 'Departments' }
    ],
    'corporate nodal officer': [
        { value: 'ADD_AREAS', label1: 'Add Areas' },
        { value: 'VIEW_AREAS', label1: 'View Areas' },
        { value: 'ACTIVE/INACTIVE_AREAS', label1: 'Active/Inactive Areas' },
        { value: 'EDIT_AREAS', label1: 'Edit Areas' },
        { value: 'DELETE_AREAS', label1: 'Delete Areas' },
        { value: 'ADD_MINES', label1: 'Add Mines' },
        { value: 'VIEW_MINES', label1: 'View Mines' },
        { value: 'EDIT_MINES', label1: 'Edit Mines' },
        { value: 'DELETE_MINES', label1: 'Delete Mines' },
        { value: 'ADD_SOURCES', label1: 'Add Sources' },
        { value: 'VIEW_SOURCES', label1: 'View Sources' },
        { value: 'EDIT_SOURCES', label1: 'Edit Sources' },
        { value: 'DELETE_SOURCES', label1: 'Delete Sources' },
        { value: 'ADD_3D_LAYER', label1: 'Add 3D Layer' },
        { value: 'VIEW_3D_LAYER', label1: 'View 3D Layer' },
        { value: 'EDIT_3D_LAYER', label1: 'Edit 3D Layer' },
        { value: 'DELETE_3D_LAYER', label1: 'Delete 3D Layer' },
        { value: 'ADD_REPORTS', label1: 'Add Reports' },
        { value: 'VIEW_REPORTS', label1: 'View Reports' },
        { value: 'EDIT_REPORTS', label1: 'Edit Reports' },
        { value: 'DELETE_REPORTS', label1: 'Delete Reports' },
        { value: 'VIEW_RECORDS', label1: 'View Records' },
        { value: 'ADD_RECORDS', label1: 'Add Records' },
        { value: 'EDIT_RECORDS', label1: 'Edit Records' },
        { value: 'DELETE_RECORDS', label1: 'Delete Records' },
        { value: 'ADD_USERS', label1: 'Add Users' },
        { value: 'VIEW_USERS', label1: 'View Users' },
        { value: 'EDIT_USERS', label1: 'Edit Users' },
        { value: 'DELETE_USERS', label1: 'Delete Users' },
        { value: 'VIEW_REQUESTS', label1: 'View Requests' },
        { value: 'TAKE_ACTION_ON_REQUESTS', label1: 'Take Action on Requests' },
        { value: 'DELETE_REQUESTS', label1: 'Delete Requests' },
        { value: 'VIEW_MODIFIED_ENTRIES', label1: 'View Modified Entries' },
        { value: 'TAKE_ACTION_ON_MODIFIED_ENTRIES', label1: 'Take Action on Modified Entries' },
        { value: 'VIEW_NEWLY_ADDED_ENTRIES', label1: 'View Newly Added Entries' },
        { value: 'TAKE_ACTION_ON_NEWLY_ADDED_ENTRIES', label1: 'Take Action on Newly Added Entries' },
        { value: 'ADD_EMPLOYEE_IDS', label1: 'Add Employee IDs' },
        { value: 'UPLOAD_EMPLOYEE_IDS', label1: 'Upload Employee IDs' },
        { value: 'VIEW_EMPLOYEE_IDS', label1: 'View Employee IDs' },
        { value: 'EDIT_EMPLOYEE_IDS', label1: 'Edit Employee IDs' },
        { value: 'DELETE_EMPLOYEE_IDS', label1: 'Delete Employee IDs' },
        { value: 'VIEW_INFORMATION_MANAGEMENT', label1: 'View Information Management' },
        {value: 'DASHBOARD', label1: 'Dashboard'},
        { value: 'DEPARTMENTS', label1: 'Departments' }

    ],
    'nodal officer': [
        { value: 'VIEW_AREAS', label1: 'View Areas' },
        { value: 'ADD_MINES', label1: 'Add Mines' },
        { value: 'VIEW_MINES', label1: 'View Mines' },
        { value: 'EDIT_MINES', label1: 'Edit Mines' },
        { value: 'DELETE_MINES', label1: 'Delete Mines' },
        { value: 'ADD_SOURCES', label1: 'Add Sources' },
        { value: 'VIEW_SOURCES', label1: 'View Sources' },
        { value: 'EDIT_SOURCES', label1: 'Edit Sources' },
        { value: 'DELETE_SOURCES', label1: 'Delete Sources' },
        { value: 'ADD_3D_LAYER', label1: 'Add 3D Layer' },
        { value: 'VIEW_3D_LAYER', label1: 'View 3D Layer' },
        { value: 'EDIT_3D_LAYER', label1: 'Edit 3D Layer' },
        { value: 'DELETE_3D_LAYER', label1: 'Delete 3D Layer' },
        { value: 'ADD_REPORTS', label1: 'Add Reports' },
        { value: 'VIEW_REPORTS', label1: 'View Reports' },
        { value: 'EDIT_REPORTS', label1: 'Edit Reports' },
        { value: 'DELETE_REPORTS', label1: 'Delete Reports' },
        { value: 'ADD_RECORDS', label1: 'Add Records' },
        { value: 'VIEW_RECORDS', label1: 'View Records' },
        { value: 'EDIT_RECORDS', label1: 'Edit Records' },
        { value: 'DELETE_RECORDS', label1: 'Delete Record' },
        { value: 'VIEW_MODIFIED_ENTRIES', label1: 'View Modified Entries' },
        { value: 'VIEW_NEWLY_ADDED_ENTRIES', label1: 'View Newly Added Entries' },
        { value: 'VIEW_INFORMATION_MANAGEMENT', label1: 'View Information Management' },
        { value: 'NODAL_OFFICER_MAP_VIEW', label1: 'Nodal Officer Map View' },
        {value: 'DASHBOARD', label1: 'Dashboard'}
    ],
    user: [
        { value: 'VIEW_CLIENT_AREAS', label1: 'View Client Areas' },
        { value: 'MAP_VIEW', label1: 'Map View' },
        { value: 'REPORTS', label1: 'Reports' },
        { value: 'DOWNLOADS', label1: 'Downloads' },
        { value: 'LAYERS', label1: 'Layers' },
        { value: 'SATELLITE', label1: 'Satellite' },
        { value: 'MEASURING_TOOL', label1: 'Measuring Tool' },
        { value: 'DEFAULT_POINTER', label1: 'Default Pointer' },
        { value: 'LEGENDS', label1: 'Legends' },
        { value: 'DRAW_TOOL', label1: 'Draw Tool' },
        { value: 'DRAWN_LAYERS', label1: 'Drawn Layers' },
        { value: 'IDENTIFIER', label1: 'Identifier' },
        { value: 'EXPORT', label1: 'Export' },
        { value: 'PRINT', label1: 'Print' },
        { value: 'ROTATE', label1: 'Rotate' },
        { value: 'COMPARISION', label1: 'Comparison' },
        { value: 'BUFFER_TOOL', label1: 'Buffer Tool' },
        { value: 'SITE_UPDATES', label1: 'Site Updates' },
        { value: '3D_SCENE', label1: '3D Scene' },
        { value: 'VOLUMETRIC_TOOL', label1: 'Volumetric Tool' },
        { value: 'PROFILE_VIEW', label1: 'Profile View' }
    ]
};

export const departments = [
    {
        value: 'survey department',
        label: 'Survey Department',
        key: 'SURVEY_DEPARTMENT'
    },
    {
        value: 'project planning department',
        label: 'Project Planning Department',
        key: 'PROJECT_PLANNING_DEPARTMENT'
    },
    {
        value: 'estates department',
        label: 'Estates Department',
        key: 'ESTATES_DEPARTMENT'
    },
    {
        value: 'environmental department',
        label: 'Environmental Department',
        key: 'ENVIRONMENTAL_DEPARTMENT'
    },
    {
        value: 'exploration department',
        label: 'Exploration Department',
        key: 'EXPLORATION_DEPARTMENT'
    },
    {
        value: 'other',
        label: 'Other',
        key: 'OTHER'
    }
];
export const privileges = {
    AREAS: {
        ADD_AREAS: 'ADD_AREAS',
        VIEW_AREAS: 'VIEW_AREAS',
        EDIT_AREAS: 'EDIT_AREAS',
        DELETE_AREAS: 'DELETE_AREAS',
        TOGGLE_AREA_STATUS: 'ACTIVE/INACTIVE_AREAS',
        VIEW_MINES: 'VIEW_MINES',
        DELIVERABLES: 'DELIVERABLES'
    },

    MINES: {
        ADD_MINES: 'ADD_MINES',
        VIEW_MINES: 'VIEW_MINES',
        EDIT_MINES: 'EDIT_MINES',
        DELETE_MINES: 'DELETE_MINES',
        VIEW_3D_LAYER: 'VIEW_3D_LAYER'
    },

    ENTRIES: {
        VIEW_INFORMATION_MANAGEMENT: 'VIEW_INFORMATION_MANAGEMENT',
        VIEW_MODIFIED_ENTRIES: 'VIEW_MODIFIED_ENTRIES',
        TAKE_ACTION_ON_MODIFIED_ENTRIES: 'TAKE_ACTION_ON_MODIFIED_ENTRIES',
        VIEW_NEWLY_ADDED_ENTRIES: 'VIEW_NEWLY_ADDED_ENTRIES',
        TAKE_ACTION_ON_NEWLY_ADDED_ENTRIES: 'TAKE_ACTION_ON_NEWLY_ADDED_ENTRIES'
    },

    REPORTS: {
        ADD_REPORTS: 'ADD_REPORTS',
        VIEW_REPORTS: 'VIEW_REPORTS',
        EDIT_REPORTS: 'EDIT_REPORTS',
        DELETE_REPORTS: 'DELETE_REPORTS'
    },

    DOWNLOADS: {
        ADD_RECORDS: 'ADD_RECORDS',
        VIEW_RECORDS: 'VIEW_RECORDS',
        EDIT_RECORDS: 'EDIT_RECORDS',
        DELETE_RECORDS: 'DELETE_RECORDS'
    },

    USERS: {
        ADD_USERS: 'ADD_USERS',
        VIEW_USERS: 'VIEW_USERS',
        EDIT_USERS: 'EDIT_USERS',
        DELETE_USERS: 'DELETE_USERS'
    },

    SOURCES: {
        ADD_SOURCES: 'ADD_SOURCES',
        VIEW_SOURCES: 'VIEW_SOURCES',
        EDIT_SOURCES: 'EDIT_SOURCES',
        DELETE_SOURCES: 'DELETE_SOURCES'
    },

    SOURCES3D: {
        ADD_3D_LAYER: 'ADD_3D_LAYER',
        VIEW_3D_LAYER: 'VIEW_3D_LAYER',
        EDIT_3D_LAYER: 'EDIT_3D_LAYER',
        DELETE_3D_LAYER: 'DELETE_3D_LAYER'
    },

    EMPLOYEEID: {
        VIEW_EMPLOYEE_IDS: 'VIEW_EMPLOYEE_IDS',
        ADD_EMPLOYEE_IDS: 'ADD_EMPLOYEE_IDS',
        EDIT_EMPLOYEE_IDS: 'EDIT_EMPLOYEE_IDS',
        DELETE_EMPLOYEE_IDS: 'DELETE_EMPLOYEE_IDS',
        UPLOAD_EMPLOYEE_IDS: 'UPLOAD_EMPLOYEE_IDS'
    },
    CLIENT_MAP: {
        MAP_VIEW: 'MAP_VIEW',
        ADMIN_MAP_VIEW: 'ADMIN_MAP_VIEW',
        NODAL_OFFICER_MAP_VIEW: 'NODAL_OFFICER_MAP_VIEW'
    },
    DASHBOARD: {
        DASHBOARD: 'DASHBOARD'
    },
    DEPARTMENTS: {
        DEPARTMENTS: 'DEPARTMENTS'
    }
};
